import { render, staticRenderFns } from "./alertsDok.vue?vue&type=template&id=3032f11d&"
import script from "./alertsDok.vue?vue&type=script&lang=js&"
export * from "./alertsDok.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports